import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const LaboratoryInfo = ({ order }: any) => {
  const { typeofSpecimen, pathologist, tumorSite, ...labInfoWithoutSpecimen } =
    order?.laboratoryInfo || {};
  const { typeofSpecimen: ignored, ...labInfoId5 } =
    order?.laboratoryInfo || {};

  delete labInfoWithoutSpecimen.specimenId;
  return (
    <div id="laboratory info">
      <CustomText
        text={
          order?.testType?.test === 8
            ? "Specimen Information"
            : "Laboratory Information"
        }
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />
      <p>Type of specimen being submitted for testing</p>

      <p className="my-2">{typeofSpecimen}</p>

      <div className="reviewCard">
        {/* Refactored to if-else and removed nested template literals for approvalSectionUrl */}
        {(() => {
          const approvalSectionUrlLab = `/access/online-order/${order.supportingSection.id}#Laboratory%20Information`;
          const approvalSectionUrlSpecimen = `/access/online-order/${order.supportingSection.id}#Specimen%20Information`;
          if (order?.testType?.test === 9) {
            return (
              <DetailRenderer
                data={{
                  ...labInfoWithoutSpecimen,
                  sampleLocationA: order?.laboratoryInfo?.sampleLocationA,
                  sampleLocationB: order?.laboratoryInfo?.sampleLocationB,
                  // isConsideredForTherapy: order?.isConsideredForTherapy,
                }}
                groupFields={[
                  "nameOfFacility",
                  "dateOfCollection",
                  // "specimenId",
                  "medicarePullDate",
                  "phone",
                  "fax",
                  "sampleLocationA",
                  "sampleLocationB",
                  // "isConsideredForTherapy",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
                approval={true}
                approvalSectionUrl={approvalSectionUrlLab}
              />
            );
          } else if (order?.testType?.test === 5) {
            return (
              <DetailRenderer
                data={labInfoId5}
                groupFields={[
                  "nameOfFacility",
                  "dateOfCollection",
                  "specimenId",
                  "medicarePullDate",
                  "phone",
                  "fax",
                  "pathologist",
                  "tumorSite",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
                approval={true}
                approvalSectionUrl={approvalSectionUrlLab}
              />
            );
          } else if (order?.testType?.test === 8) {
            return (
              <DetailRenderer
                data={order?.laboratoryInfoIDG}
                groupFields={[
                  "dateOfCollection",
                  "medicarePullDate",
                  "isTelehealth",
                  "facilityType",
                ]}
                hiddenFields={[]}
                MainHeading="Specimen"
                approval={true}
                approvalSectionUrl={approvalSectionUrlSpecimen}
              />
            );
          } else {
            return (
              <DetailRenderer
                data={labInfoWithoutSpecimen}
                groupFields={[
                  "nameOfFacility",
                  "dateOfCollection",
                  "specimenId",
                  "medicarePullDate",
                  "phone",
                  "fax",
                ]}
                hiddenFields={[]}
                MainHeading="Laboratory"
                approval={true}
                approvalSectionUrl={approvalSectionUrlLab}
              />
            );
          }
        })()}
      </div>
    </div>
  );
};

export default LaboratoryInfo;
